// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cm-main {
    position: relative;
    border-radius: 16px;
    /* padding: 60px; */
    padding: 50px;
    /* background-size: 100% 100%; */
    background-size: cover;
    background-repeat: no-repeat;
    /* background-position: center center; */
    background-position: center;
    /* background-attachment: fixed; */
    margin-top: 20px;
    max-height: 81vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

.cm-main-overlay::before {
    content: "";
    background: #000;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.2;
    border-radius: 16px;
}
.featured-video .left-arrow,
.featured-video .right-arrow {
    margin-top: 15px;
}
.left-arrow,
.right-arrow {
    background-color: #ededed;
    height: 20px;
    width: 20px;
    line-height: 18px;
    text-align: center;
    cursor: pointer;
    flex-shrink: 0;
    border-radius: 9px;
}
.left-arrow svg,
.right-arrow svg {
    width: 10px;
    height: 10px;
}

.submit-btn {
    border: none;
    background: #6c2fbb;
    color: white;
    padding: 4px 12px;
    font-size: 14px;
    border-radius: 4px;
    float: right;
}

.first-feature input {
    font-weight: 500;
    line-height: 1.2;
    font-size: 1.5rem;
}

.edit {
    display: none
}

.first-feature:hover .edit {
    display: block;
}

.seller {
    text-align: center;
    /*color: #6c2fbb;*/
    width: 100%;
    max-width: 100%;
    margin: auto;
}

.seller a {
    color: inherit;
}

.radioButtons {
    display: flex;
    gap: 15px;
}

.seller p {
    overflow-wrap: anywhere;
}

.vl {
    border-left: 1px solid #e8e8e8;
    height: 36px;
}


.leftLogoPosition {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
}

.rightLogoPosition {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    flex-direction: row-reverse;
    justify-content: flex-end;
}


@media (max-width: 425px) {
    .seller {
        max-width: 90%;
    }
    
  .title-default{
    font-size: 20px;
  }
  
  }


.seller .seller-profile .user-profile-pic {
    width: 90px !important;
    height: 90px !important;
    border-radius: 13px;
}

.seller .seller-details {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    gap: 10px;
}

.seller .seller-details.top {
    flex-flow: column;
}

/*.seller .left-image .profile-image {*/
/*    width: 60px !important;*/
/*    height: 60px !important;*/
/*    font-size: 16px;*/
/*}*/

.my-groups h2 {
    font-weight: 700;
    font-size: 28px;
    color: #0f062b;
    padding: 5px 0 20px;
    margin-bottom: 0;

}

.group-box {
    padding: 30px;
    border-radius: 16px;
    background-color: #ffff;
}

.group-box .title {
    color: #212529;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    width: 100%;
}

.subscriber-dots {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #000000a2;
    color: #fff;
    display: flex;
    cursor: initial;
    align-items: center;
    -moz-column-gap: 10px;
         column-gap: 10px;
    padding: 7px 14px;
    border-radius: 0 5px;
}

.dots {
    top: 0;
    right: 0;
    display: flex;
    cursor: pointer;
    align-items: center;
    -moz-column-gap: 10px;
         column-gap: 10px;
    padding: 7px 14px;
    border-radius: 0 5px;
    color: #6c2fbb;
}

.delete-video {
    width: 18px;
}

.group-box h4 {
    font-weight: 400;
    padding: 10px 0 0 0;
    font-size: 18px;
}

.img-box {
    aspect-ratio: 16/9;
    cursor: pointer;
    display: flex;
    justify-content: center;
    /*height: 200px;*/
    width: 100%;
    border-radius: 16px;
    overflow: hidden;
    position: relative;
    /* background: #f8f9fa; */
}

.img-box img {
    /*object-fit: contain;*/
    object-fit: fill;
}

.group-box .add-box {
    position: relative;
    width: 100%;
    /*height: 100%;*/
    height: 230px;
    border: 2px solid #6c2fbb;
    ;
    border-radius: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
}

.group-box .add-box .plus {
    width: 28px;
    height: 26px;
    background: #F8FAFB;
    border-radius: 4px;
    text-align: center;
}

.group-box .add-box h5 {
    color: #6c2fbb;
}

.view-all p {
    font-weight: 500;
    font-size: 12px;
    text-align: right;
    cursor: pointer;
    margin-top: 20px;
    margin: 0;
}

.next p {
    font-weight: 600;
    text-align: right;
    cursor: pointer;
    /* margin-top: 50px; */
    margin: 0;
}

.next p a {
    color: #6c2fbb;
}

.next p a:hover {
    text-decoration: none;
}

.group-box .col-xl-3 {
    margin-top: 10px;
}

/*.dropdown-menu {*/
/*    transform: translate3d(190px, 30px, 0px) !important;*/
/*}*/

/* .dropdown-menu {
    z-index: 2;
    top: 0px;
    left: -147px !important;
} */


.tab-box-group {
    width: 100%;
    text-align: center;
}

.tab-box-group ul,
.settings-wrapper ul {
    display: inline-flex;
    /*width: 100%;*/
    align-items: center;
    justify-content: center;
    padding-top: 8px;
    background: white;
    border-radius: 10px 10px 0 0;
    margin-bottom: 0;
    padding-left: 0;
}

.tab-box-group ul li,
.settings-wrapper ul li {
    list-style: none;
    font-weight: 500;
    font-size: 18px;
    padding: 5px 0;
    margin: 0px 25px;
    color: #878395;
    cursor: pointer;
}

.tab-box-group ul li.active,
.settings-wrapper ul li.active {
    border-top: 3px solid rgba(108, 47, 187, 1);
    color: rgba(108, 47, 187, 1);
}

.settings-wrapper {
    width: 100%;
    text-align: center;
}

.settings-wrapper ul {
    background: transparent !important;
}

/* .settings-wrapper ul li {
} */

button.btn.btnFeaturedVideo {
    background-color: #6c2fbb;
    color: white;
}

.main-featured {
    background-color: white;
    margin-top: 20px;
    padding: 17px 15px 30px;
    border-radius: 10px;
    border: 1px solid #E8E8E8;
}

.addTab {
    cursor: pointer;
    display: flex;
    gap: 5px;
    width: -moz-fit-content;
    width: fit-content;
    margin: 0 25px 0 0;
}

.addTab a {
    color: #6c2fbb;
    background: #e1e1f9;
    padding: 0 5px;
}

.addTab a i {
    font-size: 13px;
}

.addTab span {
    font-size: 16px;
    font-weight: 500;
}

.userAddedTab {
    display: flex;
    gap: 1rem;
    align-items: baseline;
    overflow: auto;
}

.userAddedTab p {
    position: relative;
    white-space: nowrap;
}

.userAddedTab p span {
    font-weight: 500;
    font-size: 17px;
    color: #878395;
    cursor: pointer;
    display: block;
    margin: 0 20px 0 0;
}

.userAddedTab p:hover .delete-tab {
    display: inline-block;
}

.delete-tab {
    display: none;
    color: #dc3545;
    position: absolute;
    top: 5px;
    right: 3px;
}

span.active {
    border-top: 3px solid #6c2fbb;
    color: #6c2fbb !important;
}

.input-search {
    position: relative;
}

.input-search-admin {
    padding-left: 28px;
    position: relative;
}

.input-searchs {
    padding-left: 32px;
}

.video-views {
    height: 300px;
    overflow-y: scroll;
    overflow-x: hidden;
}

.memmber-list {
    color: rgb(0, 0, 0);
    /* margin-right: -31px;
    margin-left: -31px; */
    padding: 7px 0px;
    cursor: pointer;
    height: 300;
    overflow-x: hidden;
}

.lecture-name {
    margin-bottom: 0rem;
}

.fa-search {
    position: absolute;
    top: 10px;
    left: 23px;
    z-index: 1;
    color: #495057a3;
}

.save-btn {
    text-align: center;
    border: none;
    outline: none;
    background: none;
    background: #6c2fbb;
    /*opacity: 0.8;*/
    color: white;
    font-size: 15px;
    padding: 6px 31px;
    border-radius: 5px;
}

::ng-deep .group-list .owl-carousel-two .owl-nav {
    display: block !important;
    width: 50px;
    position: absolute;
    bottom: 13px;
    right: 13px;
}

::ng-deep .group-list .owl-carousel .owl-nav button.owl-prev {
    /* left: 96% !important;
    top: 90% !important; */
    background: #F2F2F2 !important;
    border-radius: 9px !important;
    box-shadow: none !important;
}

::ng-deep .group-list .owl-carousel .owl-nav button.owl-next {
    /* top: 90% !important; */
    background: #F2F2F2 !important;
    border-radius: 9px !important;
    box-shadow: none !important;
}

::ng-deep .group-list .owl-carousel.owl-loading {
    opacity: unset;
    display: block;
}

.group-list .item {
    width: 250px;
    margin-right: 10px;
    height: 170px;
    margin-bottom: 5rem;
    position: relative;
    min-width: 250px;
}

.group-list .group-list-img {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    position: relative;
}

.fa-trash-alt {
    color: #de4c5a;
    font-size: 16px;
}

.dotsInImg {
    position: absolute;
    top: 12px;
    right: 15px;
    background-color: #000000a2;
    display: flex;
    cursor: pointer;
    align-items: center;
    -moz-column-gap: 10px;
         column-gap: 10px;
    padding: 4px 9px;
    border-radius: 5px;
}

.dotsInImg .dropdown-menu.dropdown-menu-right.show {
    padding: 0;
    margin: 0;
    width: 0;
    min-width: -moz-fit-content;
    min-width: fit-content;
}

.dotsInImg .dropdown-menu.dropdown-menu-right.show a {
    padding: 4px 18px 7px
}

::ng-deep .dotsInImg .dropdown-item.active,
.dropdown-item:active {
    color: black !important;
    text-decoration: none;
    background-color: transparent !important;
}

.item p {
    font-size: 14px;
    color: #878395;
    margin-top: 7px;
    height: 50px;
    overflow: auto;
    padding: 0 7px;
}

.btn-invite button {
    border: 0;
    outline: 0;
    border: 1px solid #f8f8f8;
    border-radius: 4px;
    width: 25px;
    height: 25px;
    font-size: 21px;
    color: #0f062b;
    font-weight: 900;
    background: #F0F0F0;
    line-height: 0.5;
}

.btn-invite span {
    font-weight: 400;
    font-size: 14px;
    color: #727272;
    cursor: pointer;
}

.btn-invite button .fa-sort {
    font-size: 17px;
}

.tabMenu {
    display: flex;
    align-items: center;
    position: absolute;
    right: 0;
}

.pinnedMessages{
    color: #6c2fbb;
}

hr{
    border-color: #777777;
    border-width: thin;
    margin: 4px 0 0 0;
}

.tab-box-video ul::-webkit-scrollbar {
    height: 4px;
}
@media (max-width: 1500px) {
    .group-box h4 {
        font-size: 20px;
    }

    .img-box {
        height: 172px;
    }

    .group-box .add-box {
        height: 206px;
    }
    .cm-main {
        max-height: 92vh;
    }

}
@media (max-width: 768px) {

    /*.group-box {*/
    /*    margin-top: 10px;*/
    /*}*/
    .group-box h4 {
        font-size: 18px;
    }

    .group-box {
        padding: 10px 10px;
        background-color: #ffff;
    }

    .add-box h5 {
        font-size: 18px;
    }

    .group-box .add-box {
        padding: 20px;
    }

    .discussion {
        flex-wrap: wrap;
    }

    .cm-main {
        padding: 0px;
        padding-top: 20px;
        display: block;
    }
}

.discussion-board {
    margin: 20px 0 0 0 !important;
}

.discussion-board h4 {
    margin: 20px 0 16px 0 !important;
}

/*discussion*/
.discussion-board .discussion .db-btn {
    background: #6c2fbb;
    border-radius: 8px;
    outline: none;
    border: none;
    max-width: 216px;
    width: 100%;
    height: 48px;
    color: #ffffff;
}

.discussion-board .discussion .discussion-preview {
    box-shadow: 0 .15rem .25rem rgba(0, 0, 0, .075);
    position: relative;
    border: 1px solid #3d3e3e;
    border-radius: 8px;
    padding: 5px;
    margin: 2px;
    height: 70px;
    width: 70px;
}

.discussion-board .discussion .discussion-preview .loader {
    position: absolute;
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #6c2fbb;
    width: 60px;
    height: 60px;
    /* Safari */
    animation: spin 2s linear infinite;
}

/* Safari */

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.discussion-board .discussion .discussion-preview .delete-btn {
    display: none;
    text-align: center;
    padding: 2px 5px;
    background: #D9D9D9;
    border-radius: 100%;
    position: absolute;
    line-height: 1;
    right: -10px;
    top: -10px;
}

.discussion-board .discussion .discussion-preview:hover .delete-btn {
    display: block;
}

.discussion-board .discussion {
    display: flex;
    /* align-items: center; */
    gap: 10px;
    width: 100%;
}

.discussion-board .discussion .mini-discussion {
    width: 100%;
    position: relative;
}

.discussion-board .discussion .mini-discussion textarea {
    padding: 10px;
    background: #ffffff;
    border: 1px solid #f8f8f8;
    border-radius: 8px;
    font-weight: 500;
    font-size: 15px;
    width: 100%;
    text-indent: 40px;
    outline: 0;
    /* height: 48px; */
}

.discussion-board .discussion .mini-discussion textarea::placeholder {
    color: #bbbbbb;
}

.discussion-board .discussion .mini-discussion img {
    position: absolute;
    left: 7px;
    top: 7px;
    border-radius: 4px;
    width: 32px;
    height: 32px;
    object-fit: cover;
}

::ng-deep span.spanComment p {
    /* display: flex;
    flex-direction: column; */
}


::ng-deep span.spanComment p a.highlight{
    background: #f1eafe;
    color: #6c2fbb;
}
::ng-deep span.replyComment p a.highlight{
    background: #f1eafe;
    color: #6c2fbb;
}
::ng-deep span.spanComment p a{
    background: #f1eafe;
    color: #6c2fbb;
}
::ng-deep span.replyComment p a{
    background: #f1eafe;
    color: #6c2fbb;
}
::ng-deep .ProseMirror.NgxEditor__Content p a{
    background: #f1eafe;
    color: #6c2fbb;
}


::ng-deep .NgxEditor__Content{
    height: 85px;
    overflow: auto;
    text-align: left;
}

::ng-deep #update_comment .NgxEditor__Content{
    height: auto;
    overflow: auto;
    text-align: left;
}


::ng-deep .NgxEditor__Wrapper {
    border-radius: 0 !important;
}
::ng-deep .NgxEditor__Dropdown--DropdownMenu {
    text-align: left;
}


::ng-deep #update_comment span.NgxEditor__ImageWrapper {
    width: -moz-fit-content !important;
    width: fit-content !important;
}


::ng-deep .NgxEditor__Popup .NgxEditor__Popup--FormGroup label {
    margin-bottom: 3px;
    text-align: left;
}

::ng-deep .NgxEditor__Content p{
    margin: 0 !important;
}

::ng-deep .comment-text span.spanComment p{
    margin: 0 !important;
}

::ng-deep .comment-text span.replyComment p {
    margin: 0 !important;
}

::ng-deep .comment-text span.spanComment img{
    height: 100px !important;
    width: 150px !important;
    border-radius: 4px !important; 
}
::ng-deep .comment-text span.replyComment p img{
    height: 100px !important;
    width: 150px !important;
    border-radius: 4px !important; 
}

::ng-deep #update_comment .NgxEditor__MenuBar {
    flex-wrap: nowrap !important;
    padding: 3px 0 !important;
}
::ng-deep #update_comment .NgxEditor__MenuItem.NgxEditor__MenuItem--Text {
    padding: 0 5px;
    margin-left: -3px !important;
}

#update_comment .modal-dialog{
    max-width: 530px;
}

.tagUserModal {
    position: absolute;
    background-color: #f3f3f3;
    height: 250px;
    overflow: auto;
    z-index: 1;
    /* top: -14px; */
    border: 1px solid #cccccc;
    padding: 0 5px 10px;
    width: -moz-max-content;
    width: 100%;
    border-radius: 5px;
    left: 0;
    bottom: 167px;
}

#offcanvasRight .tagUserModal {
    position: absolute;
    background-color: #f3f3f3;
    height: 250px;
    overflow: auto;
    z-index: 1;
    /* top: 33px; */
    border: 1px solid #cccccc;
    padding: 0 5px 10px;
    border-radius: 5px;
    bottom: 264px;
}

#offcanvasRight .reply {
    /* position: fixed !important;
    bottom: 70px; */
    width: 100%;
}

#offcanvasRight .demo {
    height: calc(100vh - 345px);
    overflow: auto;
}

#update_comment .tagUserModal {
    position: absolute;
    background-color: #f3f3f3;
    height: 235px;
    overflow: auto;
    z-index: 1;
    border: 1px solid #cccccc;
    padding: 0 5px 10px;
    width: 100%;
    border-radius: 5px;
    bottom: 100%;
}

.vl {
    border-left: 1px solid #cccccc;
    height: 20px;
    display: block;
}

.tagUserModal p span {
    display: block;
}

.tagUserModal p {
    padding: 4px 8px;
}

span.fullname {
    color: #8e8e8e;
}

/* .tagUserModal p:hover {
    background-color: #f1eafe !important;
    color: #6c38bf;
    border-radius: 4px;
    cursor: pointer;
} */

.tagUserModal p:hover span.fullname {
    color: white;
}

.highlighted {
    background-color: #f1eafe !important;
    color: #6c38bf;
    border-radius: 4px;
    cursor: pointer;
}


.tagUserModal p span img {
    position: unset !important;
}

.tagUserModal p span.profile-image {
    position: relative !important;
    left: 0 !important;
    line-height: 2.3;
    font-size: 13px !important;
    top: 0 !important;
    width: 28px !important;
    height: 28px !important;
}

.tagUserModal p span.username {
    font-size: 15px;
    font-weight: 500;
}

.tagUserModal input {
    font-size: 15px;
    font-weight: 500;
}

.tagUserModal .stickyClass {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: #f3f3f3;
    padding: 10px 0 2px 0;
}

.discussion-board .discussion .mini-discussion .att-btn {
    margin: 0;
    padding: 5px;
    position: absolute;
    right: 7px;
    /* top: 7px; */
    top: 3px;
    border: none;
    border-radius: 4px;
    width: 32px;
    height: 32px;
    background: #f1eafe;
    color: #6c2fbb;
}

.discussion-board .discussion .mini-discussion .profile-image {
    position: absolute;
    left: 7px;
    top: 7px;
    border-radius: 4px;
    width: 32px;
    height: 32px;
    font-size: 15px;
}

.offcanvas .profile-image{
    border-radius: 5px;
    width: 50px;
    height: 50px;
    text-align: center;
    color: #ffffff;
    background: #bd50d0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 600;
    vertical-align: middle;
    text-transform: uppercase;
    line-height: 50px;
    text-decoration: none;
    margin: 0;
}

/*.discussion-board .dis-middle .data-list {*/
/*    padding: 10px;*/
/*}*/

.discussion-board .dis-middle .data-list {
    height: 100%;
    max-height: 600px;
    padding-bottom: 5px;
    overflow: auto;
}

.pinImage {
    display: none;
}

.discussion-board .dis-middle .data-list .weekend {
    padding: 10px;
    display: flex;
    gap: 8px;
    margin: 2px;
    position: relative;
}

.discussion-board .dis-middle .data-list .weekend:hover {
    /* background-color: #fafafa; */
    box-shadow: 0 0 2px 0 rgb(0 0 0 / 50%);
}

.discussion-board .dis-middle .data-list .weekend .profile-image {
    border-radius: 4px;
    width: 32px;
    height: 32px;
    position: absolute;
    font-size: 15px;
    cursor: pointer;
}

.discussion-board .dis-middle .data-list .weekend .ago {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.discussion-board .dis-middle .data-list .weekend .ago h6 {
    cursor: pointer;
    font-weight: 500;
    font-size: 15px;
    color: #0f062b;
    margin-bottom: 0;
    margin-right: 4px;
    white-space: nowrap;
}

.discussion-board .dis-middle .data-list .weekend .ago span.span {
    font-weight: 900;
    font-size: 15px;
    color: #0f062b;
    margin: 0 5px;
}

.discussion-board .dis-middle .data-list .weekend .ago span {
    font-weight: 500;
    font-size: 12px;
    color: #878395;
}

.discussion-board .dis-middle .data-list .weekend .meni {
    width: 100%;
    margin-left: 40px;
}

.weekend .meni .comment-text {
    margin-bottom: 0;
    font-weight: 400;
    font-size: 15px;
    /*color: #878395;*/
}

.comment-text .replyComment{
    text-wrap: wrap;
    display: block;
    overflow-wrap: anywhere;
}

.discussion-board .dis-middle .data-list .weekend .meni .lier {
    display: flex;
    align-items: center;
    /* width: 400px; */
}

.discussion-board .dis-middle .data-list .weekend .meni .lier .sub {
    display: flex;
    align-items: center;
    gap: 8px;
}

.discussion-board .dis-middle .data-list .weekend .meni .lier .sub-2 {
    min-width: 150px;
    width: 100%;
}

.discussion-board .dis-middle .data-list .weekend .meni .lier .sub-2 button,
.discussion-board .dis-middle .data-list .weekend .meni .lier .sub button {
    border: 0;
    outline: 0;
    background-color: transparent;
    padding: 5px;
}

.discussion-board .dis-middle .data-list .weekend .meni .lier .sub .zero {
    font-weight: 400;
    font-size: 13px;
    color: #0f062b;
    margin-bottom: 0;
}

.discussion-board .dis-middle .data-list .weekend .meni .lier .sub-2 .zero {
    font-size: 14px;
    color: #007bff;
    font-weight: 500;
}

.discussion-board .dis-middle .data-list .weekend .meni .lier .sub-2 .zero svg {
    margin-left: 5px;
    margin-bottom: 2px;
}

.discussion-board .dis-middle .data-list .weekend:hover .meni .lier .sub-3 {
    display: flex;
}

.discussion-board .dis-middle .data-list .weekend .meni .lier .sub-3 {
    display: none;
    align-items: center;
    gap: 8px;
}

.discussion-board .dis-middle .data-list .weekend .meni .lier .sub-3 button {
    width: 59px;
    height: 30px;
    border-radius: 5px;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    border: 0;
    outline: 0;
}

.discussion-board .dis-middle .data-list .weekend .meni .lier .sub-3 button.up {
    background-color: #6c2fbb;
}

.discussion-board .dis-middle .data-list .weekend .meni .lier .sub-3 button.del {
    background-color: #c401ec;
}

.replysection:hover .replyDelete{
    display: flex;
    justify-content: end;
    padding-right: 15px;
    gap: 5px;}

.replyDelete{
    display: none;
    text-align: center;
}

.replyDelete button{
    background-color: #c401ec;
    width: 59px;
    height: 30px;
    border-radius: 5px;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    border: 0;
}


.replyDelete button.up {
    background-color: #6c2fbb;
}

.discussion-board .reply-input {
    border-left: 0;
    border-right: 0;
    border-top: 0;
    border-bottom: 0.12rem solid #80808030;
    /* background: transparent; */
    outline: none;
}

#offcanvasRight .reply-btn {
    border: none;
    background: #6c2fbb;
    color: white;
    padding: 2px 11px;
    border-radius: 4px;
    font-size: 15px;
}

.c-cmt {
    font-weight: 600;
    cursor: pointer;
}
.c-cmt:hover {
    text-decoration: underline;
}

.discussion-board .comment-video {
    cursor: pointer;
    display: inline-block;
    height: 60px;
    position: relative;
}

.discussion-board .comment-video .playicon {
    color: #6c2fbb;
    border-radius: 50%;
    font-size: 24px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.discussion-board .comment-video img {
    width: auto;
    height: inherit;
}


.update-btn {
    border: none;
    background: #8600ff;
    border-radius: 5px;
    color: white;
    padding: 4px 30px;
}

.edit-bus-btn {
    border: none;
    /*color: #6c2fbb;*/
    color: inherit;
    box-shadow: none;
    margin-left: 5px;
}

button.edit {
    margin-left: 10px;
    top: -3px;
    /* right: -35px; */
    content: "";
    width: 23px;
    height: 23px;
    background: transparent;
    border-radius: 6px;
    border: 0;
    overflow: hidden;
    position: relative;
}

#update_business_modal .form-control {
    box-shadow: none !important;
}

#update_business_modal .form-control:focus {
    border-color: #6c2fbb;
}

.video-container {
    height: 50vh;
}

.banner {
    box-shadow: 0 1px 1px rgba(0, 0, 0, 10%) !important;
    background: #6438b4;
    border: #6438b4;
    color: #fff;
    border-radius: 0;
    z-index: 1;
}

.bannerSecGuest {
    width: 100%;
    margin: 9px 0;
    /* position: absolute; */
    left: 0;
    right: 0;
    /* top: 70px; */
    top: 0;
    height: max-content;
}

.bannerSec {
    margin: 9px -22px;
    position: relative;
    /*bottom: 36px;*/
}

.rag-body {
    max-height: 80vh;
    overflow: auto;
}

.rag-list {
    width: 500px;
    max-width: 100%;
    border: solid 1px #ccc;
    min-height: 60px;
    display: block;
    background: white;
    border-radius: 4px;
    overflow: hidden;
}

.rag-box {
    padding: 10px;
    border-bottom: solid 1px #ccc;
    color: rgba(0, 0, 0, 0.87);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    cursor: move;
    background: white;
    font-size: 14px;
    z-index: 99999;
}

.rag-box:last-child {
    border: none;
}

.cdk-drag-preview {
    box-sizing: border-box;
    border-radius: 4px;
    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
        0 8px 10px 1px rgba(0, 0, 0, 0.14),
        0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.cdk-drag-animating {
    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.rag-list.cdk-drop-list-dragging .rag-box:not(.cdk-drag-placeholder) {
    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.rag-custom-placeholder {
    background: #ccc;
    border: dotted 3px #999;
    min-height: 110px;
    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.rag-img-box {
    width: 100px;
    height: 80px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    border-radius: 8px;
    background: #f8f9fa;
}

.rag-img {
    height: 100%;
    width: 100%;
    object-fit: contain;
}

/* settings */
.cm-settings {
    background-color: #eee;
    border-radius: 0 0 0 10px;
    color: #212529;
    padding: 20px 50px;
    position: fixed;
    top: 128px;
    right: 0;
    /*height: 400px;*/
    transform: translateX(100%);
    transition: transform 0.4s ease;
    z-index: 99;
}

.cm-settings.active {
    transform: translateX(0);
}

.cm-settings .toggle {
    border: none;
    cursor: pointer;
    font-size: 20px;
    padding: 10px 15px;
    position: absolute;
    top: 0;
    left: 0px;
    transform: translateX(-100%);
    background: #eee;
    color: #212121;
    border-radius: 10px 0 0 10px;
}

.cm-settings.active .toggle i {
    animation: spin 3s linear infinite;
}


/* =================================== */
.offcanvas-header {
    border-bottom: 1px solid #d2d2d2;
}

.mytextdiv {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
}

.mytexttitle {
    flex-grow: 0;
    font-size: 15px;
    color: gray;
}

.divider {
    flex-grow: 1;
    height: 1px;
    background-color: #e0dede;
}

.offcanvas-end {
    width: 600px;
}

.lastReply{
    color: gray;
    font-size: 14px;
    font-weight: 500;
}

.zero:hover{
    text-decoration: underline;
}
/* =================================== */


.tab-box-video {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 16px;
}

.tab-box-video ul {
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: auto;
    scrollbar-width: none;
    width: 100%;
    margin-bottom:0;
    /* justify-content: center; */
}

.tab-box-video ul li {
    position: relative;
    list-style: none;
    font-weight: 500;
    font-size: 18px;
    padding: 5px  10px 0 10px;
    margin: 0 15px;
    color: #878395;
    cursor: pointer;
}

.tab-box-video ul li svg {
    fill: #878395;
}

.tab-box-video ul li.active {
    border-top: 3px solid #6c2fbb;
    color: #6c2fbb;
}

.tab-box-video ul li.active svg {
    fill: rgba(108, 47, 187, 1);
}

.tab-box-video ul li .add-tab {
    color: #6c2fbb;
    background: #e1e1f9;
}

.tab-box-video ul li .delete-tab-2 {
    display: none;
    color: #dc3545;
}

.edit-tab svg {
    height: 16px;
    width: 16px;
    fill: black !important;
    margin-right: 5px;
    display: none;
}

.isPinned {
    background-color: #f1eafe8c;
    border: 1px solid #ae88df;
    border-radius: 4px;
}

.tab-box-video ul li:hover .delete-tab-2 {
    display: inline-block;
} 

.tab-box-video ul li:hover .edit-tab svg {
    display: inline-block;
}

.tab-box-video ul li:hover .pinImage {
    display: inline-block;
}


.discussionBoard h2{
    width: 100%;
    max-width: -moz-fit-content;
    max-width: fit-content;
}

.discussionBoard .tab-box-video ul li .delete-tab-2 {
    display: none;
    color: #dc3545;
    position: unset;
    padding: 0 0 0 5px;
}
.discussionBoard  .tab-box-video ul li:hover .delete-tab-2 {
    display: inline-block;
}

#reOrderGroupTopic .rag-box {
    padding: 10px;
    border-bottom: solid 1px #ccc;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    cursor: move;
    background: white;
    z-index: 99999;
    font-size: 18px;
    font-weight: 500;
    color: #878395;
}

#reOrderGroupTopic .rag-custom-placeholder {
    background: #ccc;
    border: dotted 3px #999;
    min-height: 50px;
    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

::ng-deep .pricing-dialog {
    overflow: auto;
}

::ng-deep .pricing-dialog .mat-dialog-container{

    display: block;
    padding: 24px;
    border-radius: 4px;
    box-sizing: border-box;
    overflow: auto;
    outline: 0;
    width: 100%;
    height: 100%;
    min-height: inherit;
    max-height: inherit;
    margin: 20px 0;

}


@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.cm-settings .settings ul {
    list-style: none;
}

.cm-settings .settings ul li {
    margin: 20px 0;
}

.template-1-main {
    background-color: #fff;
    border-radius: 16px;
}

.template-1-header .seller-profile {
    padding: 18px 40px;
    border-bottom: 1px solid #dee2e6;
    text-align: right;
}

.template-1-header .seller-profile .user-profile-pic {
    width: 50px !important;
    height: 50px !important;
    border-radius: 13px;
    margin-right: 10px;
}

.templates-option li {
    cursor: pointer;
}

.templates-option li:hover,
.templates-option li.active {
    color: #6c2fbb;
}

.panels {
    border-radius: 16px;
    border: 1px solid #dee2e6;
}

.iframe-video {
    border-radius: 16px;
}

.mobile-view a {
    color: inherit;
}

.attachments .attachments-item {
    width: auto !important;
}

.actionButton{
    /* position: absolute; */
    bottom: 0;
    display: flex;
    gap: 10px;
    width: 100%;
    justify-content: flex-end;;
    padding: 5px;
    background-color: white;
    /* border: 1px solid #959697; */
    /* border-top: 1px solid #d6d6d6; */
    border-left: 1px solid #959697;
    border-right: 1px solid #959697;
    border-bottom: 1px solid #959697;
}

.reply .actionButton{
    bottom: 100px !important;
}

.actionButton button{
    border-radius: 5px !important;
    padding: 4px 8px !important;
    height: unset !important;
    width: unset !important;
    border: none !important;
}

.actionButton button img{
    filter: invert(1);
    position: unset !important;
    height: 20px !important;
    width: 20px !important;
}

.actionButton button label{
    color: white !important;
    padding: 0 !important;
    margin: 0 !important;
    position: unset !important;
    background-color: unset !important;
    height: unset !important;
    width: unset !important;
}
.actionButton .btnCancelReply {
    background: #6c2fbb;
    border-radius: 5px !important;
    padding: 4px 8px;
    height: unset !important;
    width: unset !important;
    font-size: 15px;
    color: white;
    border: none !important;
}
.btnJoin{
    width: -moz-fit-content;
    width: fit-content;
    border-radius: 5px;
    border: solid 1px #6c2fbb;
    background-color: #6c2fbb;
    font-size: 15px;
    padding: 5px 25px;
    color: white;
}

.btnCancel{
    width: -moz-fit-content;
    width: fit-content;
    /* margin: 0; */
    border-radius: 5px;
    border: none;
    background-color: #6c2fbbd1;
    font-size: 15px;
    padding: 6px 15px;
    /* width: 100%; */
    color: white;
}

.errorMsg{
    text-align: center;
    margin: 33px 0 10px 0;
    font-size: 18px;
}

#modalForAllGroups .title{
    color: #212529;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    font-size: 17px;
    margin-top: 7px;
    font-weight: 400 
}
#modalForAllGroups .modal-body {
    height: calc(100vh - 200px);
    overflow-y: auto;
}
::ng-deep .tooltip001 {
    position: absolute;
    background-color: white;
    border: 1px solid #ccc;
    padding: 10px 13px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    z-index: 1000; 
}
::ng-deep .tooltip001 span {
   display: flex;
   align-items: center;
   gap: 10px;
}
::ng-deep .tooltip001 img {
    width: 50px;
    height: 50px;
    border-radius: 5px;
}
::ng-deep .tooltip001 .profile-image {
    width: 50px;
    height: 50px;
    border-radius: 5px;
    font-size: 18px;
}

@media (max-width: 1199px) {
    .cm-main { 
        max-height: unset;
        height: auto;
    }
    .mobile-view,
    .mobile-view-name {
        text-align: center;
        justify-content: center;
    }
    .main-featured .tabMenu {
        position: unset;
        justify-content: flex-end;
        width: 100%;
    }
    .main-featured .userAddedTab {
        gap: 0;
        margin-top: 10px;
        width: 100%;
        margin-bottom: 15px;
    }
}
@media (max-width: 991px) {
    .edit-tab svg{
        display: inline-block !important;
    }

        .pinImage {
            display: inline-block !important;
        }

    .userAddedTab p span {
        margin: 0 24px 0 0;
    }
    .delete-tab {
        display: block;
        right: 12px;
    }
    .tab-box-video ul li .delete-tab-2 {
        display: inline-block;
    }
}
@media (max-width: 768px) {
    .tab-box-video {
        align-items: baseline;
    }
    .tab-box-video ul {
        margin-inline: 10px;
    }
    .featured-video {
        display: flex;
        overflow-x: auto;
        overflow-y: hidden;
    }
    .featured-video .userAddedTab {
        margin-inline: 10px;
    }
}
@media (max-width: 600px) {
    .group-box {
        border-radius: 0 0 16px 16px;
    }
}
@media (max-width: 575px) {
    .lier {
        flex-direction: column;
        align-items: flex-start !important;
    }
    .lier .sub-2 {
        width: 100% !important;
    }
    .lier .sub-2 img {
        width: 22px;
    }
    .cm-settings {
        padding: 20px;
    }
}
@media (max-width: 450px) {
    .light-scroll.memmber-list {
        flex-wrap: nowrap;
    }
    .light-scroll.memmber-list >div:first-child {
        padding: 0;
    }
    .light-scroll.memmber-list >div:nth-child(2) {
        padding-right: 0;
    }
    .light-scroll.memmber-list >div .lecture-name {
        margin-left: 10px;
    }
    .cm-settings {
        width: 260px;
    }
    .cm-settings .settings-wrapper ul {
        flex-wrap: wrap;
    }
    .cm-settings .settings-wrapper ul li {
       margin: 0;
    }
    .cm-settings ul li .btnFeaturedVideo {
       font-size: 13px;
    }
    #offcanvasRight .offcanvas-body .position-sticky {
        margin-top: -50px;
    }
}
@media (max-width: 430px) {
    .tab-box-group ul {
        flex-direction: column;
        border-bottom: 1px solid #e5e5e5;
        width: 100%;
        padding-bottom: 10px;
        padding-top: 17px;    
    }
    .group-box .dots {
        padding-inline: 5px;
    }
    .group-box .next p {
        margin: 0 !important;
    }
    .group-box .next p a {
       font-size: 14px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/main-community/main-community.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,sBAAsB;IACtB,4BAA4B;IAC5B,wCAAwC;IACxC,2BAA2B;IAC3B,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,mBAAmB;AACvB;AACA;;IAEI,gBAAgB;AACpB;AACA;;IAEI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;AACA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,yBAAyB;AAC7B;;;AAGA;IACI;QACI,cAAc;IAClB;;EAEF;IACE,eAAe;EACjB;;EAEA;;;AAGF;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA,uCAAuC;AACvC,8BAA8B;AAC9B,+BAA+B;AAC/B,uBAAuB;AACvB,IAAI;;AAEJ;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,qBAAgB;SAAhB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,MAAM;IACN,QAAQ;IACR,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,qBAAgB;SAAhB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,yBAAyB;;IAEzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB,2DAA2D;AAC3D,IAAI;;AAEJ;;;;GAIG;;;AAGH;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;;IAEI,2CAA2C;IAC3C,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;GACG;;AAEH;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,QAAQ;IACR,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB;yBACqB;IACrB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;0BACsB;IACtB,8BAA8B;IAC9B,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,2BAA2B;IAC3B,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,qBAAgB;SAAhB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,QAAQ;IACR,2BAAsB;IAAtB,sBAAsB;AAC1B;;AAEA;IACI;AACJ;;AAEA;;IAEI,uBAAuB;IACvB,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,YAAY;IACZ,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;AACA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;IACpB;;AAEJ;AACA;;IAEI,eAAe;IACf,wBAAwB;IACxB,IAAI;IACJ;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;AACpC;;AAEA,aAAa;AACb;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;IACX,YAAY;IAEZ,WAAW;IACX,kCAAkC;AACtC;;AAEA,WAAW;;AAWX;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI;6BACyB;AAC7B;;;AAGA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;;;AAGA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;;AAGA;IACI,2BAA2B;AAC/B;AACA;IACI,gBAAgB;AACpB;;;AAGA;IACI,kCAA6B;IAA7B,6BAA6B;AACjC;;;AAGA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,6BAA6B;AACjC;AACA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,UAAU;IACV,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI;mBACe;IACf,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,UAAU;IACV,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;;GAKG;;AAEH;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;;AAGA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,SAAS;AACb;;AAEA,6CAA6C;AAC7C,qBAAqB;AACrB,IAAI;;AAEJ;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,QAAQ;IACR,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;;IAEI,SAAS;IACT,UAAU;IACV,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,SAAS;IACT,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ,CAAC;;AAEb;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,SAAS;AACb;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;IACb,sCAAsC;IACtC,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,QAAQ;IAKR,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;;AAGA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mDAAmD;IACnD,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,wBAAwB;IACxB,OAAO;IACP,QAAQ;IACR,eAAe;IACf,MAAM;IACN,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB;;0CAEsC;AAC1C;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,sDAAsD;AAC1D;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA,aAAa;AACb;IACI,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,QAAQ;IACR,iBAAiB;IACjB,2BAA2B;IAC3B,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,4BAA4B;IAC5B,gBAAgB;IAChB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,kCAAkC;AACtC;;;AAGA,wCAAwC;AACxC;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;AACA,wCAAwC;;;AAGxC;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,WAAW;IACX,2BAAsB;IAAtB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,sDAAsD;AAC1D;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;;AAElB;;;AAGA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,SAAS;IACT,aAAa;IACb,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,uBAAuB;IACvB,+BAA+B;IAC/B,mCAAmC;IACnC,8BAA8B;IAC9B,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;IACpB,0BAA0B;IAC1B,kCAAkC;IAClC,wBAAwB;IACxB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,wBAAwB;IACxB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,uBAAkB;IAAlB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf;AACJ;AACA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,qCAAqC;IACrC,aAAa;AACjB;AACA;GACG,aAAa;GACb,mBAAmB;GACnB,SAAS;AACZ;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI;QACI,iBAAiB;QACjB,YAAY;IAChB;IACA;;QAEI,kBAAkB;QAClB,uBAAuB;IAC3B;IACA;QACI,eAAe;QACf,yBAAyB;QACzB,WAAW;IACf;IACA;QACI,MAAM;QACN,gBAAgB;QAChB,WAAW;QACX,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,gCAAgC;IACpC;;QAEI;YACI,gCAAgC;QACpC;;IAEJ;QACI,kBAAkB;IACtB;IACA;QACI,cAAc;QACd,WAAW;IACf;IACA;QACI,qBAAqB;IACzB;AACJ;AACA;IACI;QACI,qBAAqB;IACzB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,4BAA4B;IAChC;AACJ;AACA;IACI;QACI,sBAAsB;QACtB,kCAAkC;IACtC;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,UAAU;IACd;IACA;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;OACG,SAAS;IACZ;IACA;OACG,eAAe;IAClB;IACA;QACI,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,sBAAsB;QACtB,gCAAgC;QAChC,WAAW;QACX,oBAAoB;QACpB,iBAAiB;IACrB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,oBAAoB;IACxB;IACA;OACG,eAAe;IAClB;AACJ","sourcesContent":[".cm-main {\n    position: relative;\n    border-radius: 16px;\n    /* padding: 60px; */\n    padding: 50px;\n    /* background-size: 100% 100%; */\n    background-size: cover;\n    background-repeat: no-repeat;\n    /* background-position: center center; */\n    background-position: center;\n    /* background-attachment: fixed; */\n    margin-top: 20px;\n    max-height: 81vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.cm-main-overlay::before {\n    content: \"\";\n    background: #000;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0.2;\n    border-radius: 16px;\n}\n.featured-video .left-arrow,\n.featured-video .right-arrow {\n    margin-top: 15px;\n}\n.left-arrow,\n.right-arrow {\n    background-color: #ededed;\n    height: 20px;\n    width: 20px;\n    line-height: 18px;\n    text-align: center;\n    cursor: pointer;\n    flex-shrink: 0;\n    border-radius: 9px;\n}\n.left-arrow svg,\n.right-arrow svg {\n    width: 10px;\n    height: 10px;\n}\n\n.submit-btn {\n    border: none;\n    background: #6c2fbb;\n    color: white;\n    padding: 4px 12px;\n    font-size: 14px;\n    border-radius: 4px;\n    float: right;\n}\n\n.first-feature input {\n    font-weight: 500;\n    line-height: 1.2;\n    font-size: 1.5rem;\n}\n\n.edit {\n    display: none\n}\n\n.first-feature:hover .edit {\n    display: block;\n}\n\n.seller {\n    text-align: center;\n    /*color: #6c2fbb;*/\n    width: 100%;\n    max-width: 100%;\n    margin: auto;\n}\n\n.seller a {\n    color: inherit;\n}\n\n.radioButtons {\n    display: flex;\n    gap: 15px;\n}\n\n.seller p {\n    overflow-wrap: anywhere;\n}\n\n.vl {\n    border-left: 1px solid #e8e8e8;\n    height: 36px;\n}\n\n\n.leftLogoPosition {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 10px;\n}\n\n.rightLogoPosition {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 10px;\n    flex-direction: row-reverse;\n    justify-content: flex-end;\n}\n\n\n@media (max-width: 425px) {\n    .seller {\n        max-width: 90%;\n    }\n    \n  .title-default{\n    font-size: 20px;\n  }\n  \n  }\n\n\n.seller .seller-profile .user-profile-pic {\n    width: 90px !important;\n    height: 90px !important;\n    border-radius: 13px;\n}\n\n.seller .seller-details {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1rem;\n    gap: 10px;\n}\n\n.seller .seller-details.top {\n    flex-flow: column;\n}\n\n/*.seller .left-image .profile-image {*/\n/*    width: 60px !important;*/\n/*    height: 60px !important;*/\n/*    font-size: 16px;*/\n/*}*/\n\n.my-groups h2 {\n    font-weight: 700;\n    font-size: 28px;\n    color: #0f062b;\n    padding: 5px 0 20px;\n    margin-bottom: 0;\n\n}\n\n.group-box {\n    padding: 30px;\n    border-radius: 16px;\n    background-color: #ffff;\n}\n\n.group-box .title {\n    color: #212529;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-align: center;\n    width: 100%;\n}\n\n.subscriber-dots {\n    position: absolute;\n    top: 0;\n    right: 0;\n    background-color: #000000a2;\n    color: #fff;\n    display: flex;\n    cursor: initial;\n    align-items: center;\n    column-gap: 10px;\n    padding: 7px 14px;\n    border-radius: 0 5px;\n}\n\n.dots {\n    top: 0;\n    right: 0;\n    display: flex;\n    cursor: pointer;\n    align-items: center;\n    column-gap: 10px;\n    padding: 7px 14px;\n    border-radius: 0 5px;\n    color: #6c2fbb;\n}\n\n.delete-video {\n    width: 18px;\n}\n\n.group-box h4 {\n    font-weight: 400;\n    padding: 10px 0 0 0;\n    font-size: 18px;\n}\n\n.img-box {\n    aspect-ratio: 16/9;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    /*height: 200px;*/\n    width: 100%;\n    border-radius: 16px;\n    overflow: hidden;\n    position: relative;\n    /* background: #f8f9fa; */\n}\n\n.img-box img {\n    /*object-fit: contain;*/\n    object-fit: fill;\n}\n\n.group-box .add-box {\n    position: relative;\n    width: 100%;\n    /*height: 100%;*/\n    height: 230px;\n    border: 2px solid #6c2fbb;\n    ;\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.group-box .add-box .plus {\n    width: 28px;\n    height: 26px;\n    background: #F8FAFB;\n    border-radius: 4px;\n    text-align: center;\n}\n\n.group-box .add-box h5 {\n    color: #6c2fbb;\n}\n\n.view-all p {\n    font-weight: 500;\n    font-size: 12px;\n    text-align: right;\n    cursor: pointer;\n    margin-top: 20px;\n    margin: 0;\n}\n\n.next p {\n    font-weight: 600;\n    text-align: right;\n    cursor: pointer;\n    /* margin-top: 50px; */\n    margin: 0;\n}\n\n.next p a {\n    color: #6c2fbb;\n}\n\n.next p a:hover {\n    text-decoration: none;\n}\n\n.group-box .col-xl-3 {\n    margin-top: 10px;\n}\n\n/*.dropdown-menu {*/\n/*    transform: translate3d(190px, 30px, 0px) !important;*/\n/*}*/\n\n/* .dropdown-menu {\n    z-index: 2;\n    top: 0px;\n    left: -147px !important;\n} */\n\n\n.tab-box-group {\n    width: 100%;\n    text-align: center;\n}\n\n.tab-box-group ul,\n.settings-wrapper ul {\n    display: inline-flex;\n    /*width: 100%;*/\n    align-items: center;\n    justify-content: center;\n    padding-top: 8px;\n    background: white;\n    border-radius: 10px 10px 0 0;\n    margin-bottom: 0;\n    padding-left: 0;\n}\n\n.tab-box-group ul li,\n.settings-wrapper ul li {\n    list-style: none;\n    font-weight: 500;\n    font-size: 18px;\n    padding: 5px 0;\n    margin: 0px 25px;\n    color: #878395;\n    cursor: pointer;\n}\n\n.tab-box-group ul li.active,\n.settings-wrapper ul li.active {\n    border-top: 3px solid rgba(108, 47, 187, 1);\n    color: rgba(108, 47, 187, 1);\n}\n\n.settings-wrapper {\n    width: 100%;\n    text-align: center;\n}\n\n.settings-wrapper ul {\n    background: transparent !important;\n}\n\n/* .settings-wrapper ul li {\n} */\n\nbutton.btn.btnFeaturedVideo {\n    background-color: #6c2fbb;\n    color: white;\n}\n\n.main-featured {\n    background-color: white;\n    margin-top: 20px;\n    padding: 17px 15px 30px;\n    border-radius: 10px;\n    border: 1px solid #E8E8E8;\n}\n\n.addTab {\n    cursor: pointer;\n    display: flex;\n    gap: 5px;\n    width: fit-content;\n    margin: 0 25px 0 0;\n}\n\n.addTab a {\n    color: #6c2fbb;\n    background: #e1e1f9;\n    padding: 0 5px;\n}\n\n.addTab a i {\n    font-size: 13px;\n}\n\n.addTab span {\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.userAddedTab {\n    display: flex;\n    gap: 1rem;\n    align-items: baseline;\n    overflow: auto;\n}\n\n.userAddedTab p {\n    position: relative;\n    white-space: nowrap;\n}\n\n.userAddedTab p span {\n    font-weight: 500;\n    font-size: 17px;\n    color: #878395;\n    cursor: pointer;\n    display: block;\n    margin: 0 20px 0 0;\n}\n\n.userAddedTab p:hover .delete-tab {\n    display: inline-block;\n}\n\n.delete-tab {\n    display: none;\n    color: #dc3545;\n    position: absolute;\n    top: 5px;\n    right: 3px;\n}\n\nspan.active {\n    border-top: 3px solid #6c2fbb;\n    color: #6c2fbb !important;\n}\n\n.input-search {\n    position: relative;\n}\n\n.input-search-admin {\n    padding-left: 28px;\n    position: relative;\n}\n\n.input-searchs {\n    padding-left: 32px;\n}\n\n.video-views {\n    height: 300px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n}\n\n.memmber-list {\n    color: rgb(0, 0, 0);\n    /* margin-right: -31px;\n    margin-left: -31px; */\n    padding: 7px 0px;\n    cursor: pointer;\n    height: 300;\n    overflow-x: hidden;\n}\n\n.lecture-name {\n    margin-bottom: 0rem;\n}\n\n.fa-search {\n    position: absolute;\n    top: 10px;\n    left: 23px;\n    z-index: 1;\n    color: #495057a3;\n}\n\n.save-btn {\n    text-align: center;\n    border: none;\n    outline: none;\n    background: none;\n    background: #6c2fbb;\n    /*opacity: 0.8;*/\n    color: white;\n    font-size: 15px;\n    padding: 6px 31px;\n    border-radius: 5px;\n}\n\n::ng-deep .group-list .owl-carousel-two .owl-nav {\n    display: block !important;\n    width: 50px;\n    position: absolute;\n    bottom: 13px;\n    right: 13px;\n}\n\n::ng-deep .group-list .owl-carousel .owl-nav button.owl-prev {\n    /* left: 96% !important;\n    top: 90% !important; */\n    background: #F2F2F2 !important;\n    border-radius: 9px !important;\n    box-shadow: none !important;\n}\n\n::ng-deep .group-list .owl-carousel .owl-nav button.owl-next {\n    /* top: 90% !important; */\n    background: #F2F2F2 !important;\n    border-radius: 9px !important;\n    box-shadow: none !important;\n}\n\n::ng-deep .group-list .owl-carousel.owl-loading {\n    opacity: unset;\n    display: block;\n}\n\n.group-list .item {\n    width: 250px;\n    margin-right: 10px;\n    height: 170px;\n    margin-bottom: 5rem;\n    position: relative;\n    min-width: 250px;\n}\n\n.group-list .group-list-img {\n    width: 100%;\n    height: 100%;\n    border-radius: 10px;\n    position: relative;\n}\n\n.fa-trash-alt {\n    color: #de4c5a;\n    font-size: 16px;\n}\n\n.dotsInImg {\n    position: absolute;\n    top: 12px;\n    right: 15px;\n    background-color: #000000a2;\n    display: flex;\n    cursor: pointer;\n    align-items: center;\n    column-gap: 10px;\n    padding: 4px 9px;\n    border-radius: 5px;\n}\n\n.dotsInImg .dropdown-menu.dropdown-menu-right.show {\n    padding: 0;\n    margin: 0;\n    width: 0;\n    min-width: fit-content;\n}\n\n.dotsInImg .dropdown-menu.dropdown-menu-right.show a {\n    padding: 4px 18px 7px\n}\n\n::ng-deep .dotsInImg .dropdown-item.active,\n.dropdown-item:active {\n    color: black !important;\n    text-decoration: none;\n    background-color: transparent !important;\n}\n\n.item p {\n    font-size: 14px;\n    color: #878395;\n    margin-top: 7px;\n    height: 50px;\n    overflow: auto;\n    padding: 0 7px;\n}\n\n.btn-invite button {\n    border: 0;\n    outline: 0;\n    border: 1px solid #f8f8f8;\n    border-radius: 4px;\n    width: 25px;\n    height: 25px;\n    font-size: 21px;\n    color: #0f062b;\n    font-weight: 900;\n    background: #F0F0F0;\n    line-height: 0.5;\n}\n\n.btn-invite span {\n    font-weight: 400;\n    font-size: 14px;\n    color: #727272;\n    cursor: pointer;\n}\n\n.btn-invite button .fa-sort {\n    font-size: 17px;\n}\n\n.tabMenu {\n    display: flex;\n    align-items: center;\n    position: absolute;\n    right: 0;\n}\n\n.pinnedMessages{\n    color: #6c2fbb;\n}\n\nhr{\n    border-color: #777777;\n    border-width: thin;\n    margin: 4px 0 0 0;\n}\n\n.tab-box-video ul::-webkit-scrollbar {\n    height: 4px;\n}\n@media (max-width: 1500px) {\n    .group-box h4 {\n        font-size: 20px;\n    }\n\n    .img-box {\n        height: 172px;\n    }\n\n    .group-box .add-box {\n        height: 206px;\n    }\n    .cm-main {\n        max-height: 92vh;\n    }\n\n}\n@media (max-width: 768px) {\n\n    /*.group-box {*/\n    /*    margin-top: 10px;*/\n    /*}*/\n    .group-box h4 {\n        font-size: 18px;\n    }\n\n    .group-box {\n        padding: 10px 10px;\n        background-color: #ffff;\n    }\n\n    .add-box h5 {\n        font-size: 18px;\n    }\n\n    .group-box .add-box {\n        padding: 20px;\n    }\n\n    .discussion {\n        flex-wrap: wrap;\n    }\n\n    .cm-main {\n        padding: 0px;\n        padding-top: 20px;\n        display: block;\n    }\n}\n\n.discussion-board {\n    margin: 20px 0 0 0 !important;\n}\n\n.discussion-board h4 {\n    margin: 20px 0 16px 0 !important;\n}\n\n/*discussion*/\n.discussion-board .discussion .db-btn {\n    background: #6c2fbb;\n    border-radius: 8px;\n    outline: none;\n    border: none;\n    max-width: 216px;\n    width: 100%;\n    height: 48px;\n    color: #ffffff;\n}\n\n.discussion-board .discussion .discussion-preview {\n    box-shadow: 0 .15rem .25rem rgba(0, 0, 0, .075);\n    position: relative;\n    border: 1px solid #3d3e3e;\n    border-radius: 8px;\n    padding: 5px;\n    margin: 2px;\n    height: 70px;\n    width: 70px;\n}\n\n.discussion-board .discussion .discussion-preview .loader {\n    position: absolute;\n    border: 5px solid #f3f3f3;\n    border-radius: 50%;\n    border-top: 5px solid #6c2fbb;\n    width: 60px;\n    height: 60px;\n    -webkit-animation: spin 2s linear infinite;\n    /* Safari */\n    animation: spin 2s linear infinite;\n}\n\n/* Safari */\n@-webkit-keyframes spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n    }\n\n    100% {\n        -webkit-transform: rotate(360deg);\n    }\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.discussion-board .discussion .discussion-preview .delete-btn {\n    display: none;\n    text-align: center;\n    padding: 2px 5px;\n    background: #D9D9D9;\n    border-radius: 100%;\n    position: absolute;\n    line-height: 1;\n    right: -10px;\n    top: -10px;\n}\n\n.discussion-board .discussion .discussion-preview:hover .delete-btn {\n    display: block;\n}\n\n.discussion-board .discussion {\n    display: flex;\n    /* align-items: center; */\n    gap: 10px;\n    width: 100%;\n}\n\n.discussion-board .discussion .mini-discussion {\n    width: 100%;\n    position: relative;\n}\n\n.discussion-board .discussion .mini-discussion textarea {\n    padding: 10px;\n    background: #ffffff;\n    border: 1px solid #f8f8f8;\n    border-radius: 8px;\n    font-weight: 500;\n    font-size: 15px;\n    width: 100%;\n    text-indent: 40px;\n    outline: 0;\n    /* height: 48px; */\n}\n\n.discussion-board .discussion .mini-discussion textarea::placeholder {\n    color: #bbbbbb;\n}\n\n.discussion-board .discussion .mini-discussion img {\n    position: absolute;\n    left: 7px;\n    top: 7px;\n    border-radius: 4px;\n    width: 32px;\n    height: 32px;\n    object-fit: cover;\n}\n\n::ng-deep span.spanComment p {\n    /* display: flex;\n    flex-direction: column; */\n}\n\n\n::ng-deep span.spanComment p a.highlight{\n    background: #f1eafe;\n    color: #6c2fbb;\n}\n::ng-deep span.replyComment p a.highlight{\n    background: #f1eafe;\n    color: #6c2fbb;\n}\n::ng-deep span.spanComment p a{\n    background: #f1eafe;\n    color: #6c2fbb;\n}\n::ng-deep span.replyComment p a{\n    background: #f1eafe;\n    color: #6c2fbb;\n}\n::ng-deep .ProseMirror.NgxEditor__Content p a{\n    background: #f1eafe;\n    color: #6c2fbb;\n}\n\n\n::ng-deep .NgxEditor__Content{\n    height: 85px;\n    overflow: auto;\n    text-align: left;\n}\n\n::ng-deep #update_comment .NgxEditor__Content{\n    height: auto;\n    overflow: auto;\n    text-align: left;\n}\n\n\n::ng-deep .NgxEditor__Wrapper {\n    border-radius: 0 !important;\n}\n::ng-deep .NgxEditor__Dropdown--DropdownMenu {\n    text-align: left;\n}\n\n\n::ng-deep #update_comment span.NgxEditor__ImageWrapper {\n    width: fit-content !important;\n}\n\n\n::ng-deep .NgxEditor__Popup .NgxEditor__Popup--FormGroup label {\n    margin-bottom: 3px;\n    text-align: left;\n}\n\n::ng-deep .NgxEditor__Content p{\n    margin: 0 !important;\n}\n\n::ng-deep .comment-text span.spanComment p{\n    margin: 0 !important;\n}\n\n::ng-deep .comment-text span.replyComment p {\n    margin: 0 !important;\n}\n\n::ng-deep .comment-text span.spanComment img{\n    height: 100px !important;\n    width: 150px !important;\n    border-radius: 4px !important; \n}\n::ng-deep .comment-text span.replyComment p img{\n    height: 100px !important;\n    width: 150px !important;\n    border-radius: 4px !important; \n}\n\n::ng-deep #update_comment .NgxEditor__MenuBar {\n    flex-wrap: nowrap !important;\n    padding: 3px 0 !important;\n}\n::ng-deep #update_comment .NgxEditor__MenuItem.NgxEditor__MenuItem--Text {\n    padding: 0 5px;\n    margin-left: -3px !important;\n}\n\n#update_comment .modal-dialog{\n    max-width: 530px;\n}\n\n.tagUserModal {\n    position: absolute;\n    background-color: #f3f3f3;\n    height: 250px;\n    overflow: auto;\n    z-index: 1;\n    /* top: -14px; */\n    border: 1px solid #cccccc;\n    padding: 0 5px 10px;\n    width: -moz-max-content;\n    width: 100%;\n    border-radius: 5px;\n    left: 0;\n    bottom: 167px;\n}\n\n#offcanvasRight .tagUserModal {\n    position: absolute;\n    background-color: #f3f3f3;\n    height: 250px;\n    overflow: auto;\n    z-index: 1;\n    /* top: 33px; */\n    border: 1px solid #cccccc;\n    padding: 0 5px 10px;\n    border-radius: 5px;\n    bottom: 264px;\n}\n\n#offcanvasRight .reply {\n    /* position: fixed !important;\n    bottom: 70px; */\n    width: 100%;\n}\n\n#offcanvasRight .demo {\n    height: calc(100vh - 345px);\n    overflow: auto;\n}\n\n#update_comment .tagUserModal {\n    position: absolute;\n    background-color: #f3f3f3;\n    height: 235px;\n    overflow: auto;\n    z-index: 1;\n    border: 1px solid #cccccc;\n    padding: 0 5px 10px;\n    width: 100%;\n    border-radius: 5px;\n    bottom: 100%;\n}\n\n.vl {\n    border-left: 1px solid #cccccc;\n    height: 20px;\n    display: block;\n}\n\n.tagUserModal p span {\n    display: block;\n}\n\n.tagUserModal p {\n    padding: 4px 8px;\n}\n\nspan.fullname {\n    color: #8e8e8e;\n}\n\n/* .tagUserModal p:hover {\n    background-color: #f1eafe !important;\n    color: #6c38bf;\n    border-radius: 4px;\n    cursor: pointer;\n} */\n\n.tagUserModal p:hover span.fullname {\n    color: white;\n}\n\n.highlighted {\n    background-color: #f1eafe !important;\n    color: #6c38bf;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n\n.tagUserModal p span img {\n    position: unset !important;\n}\n\n.tagUserModal p span.profile-image {\n    position: relative !important;\n    left: 0 !important;\n    line-height: 2.3;\n    font-size: 13px !important;\n    top: 0 !important;\n    width: 28px !important;\n    height: 28px !important;\n}\n\n.tagUserModal p span.username {\n    font-size: 15px;\n    font-weight: 500;\n}\n\n.tagUserModal input {\n    font-size: 15px;\n    font-weight: 500;\n}\n\n.tagUserModal .stickyClass {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    background-color: #f3f3f3;\n    padding: 10px 0 2px 0;\n}\n\n.discussion-board .discussion .mini-discussion .att-btn {\n    margin: 0;\n    padding: 5px;\n    position: absolute;\n    right: 7px;\n    /* top: 7px; */\n    top: 3px;\n    border: none;\n    border-radius: 4px;\n    width: 32px;\n    height: 32px;\n    background: #f1eafe;\n    color: #6c2fbb;\n}\n\n.discussion-board .discussion .mini-discussion .profile-image {\n    position: absolute;\n    left: 7px;\n    top: 7px;\n    border-radius: 4px;\n    width: 32px;\n    height: 32px;\n    font-size: 15px;\n}\n\n.offcanvas .profile-image{\n    border-radius: 5px;\n    width: 50px;\n    height: 50px;\n    text-align: center;\n    color: #ffffff;\n    background: #bd50d0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 20px;\n    font-weight: 600;\n    vertical-align: middle;\n    text-transform: uppercase;\n    line-height: 50px;\n    text-decoration: none;\n    margin: 0;\n}\n\n/*.discussion-board .dis-middle .data-list {*/\n/*    padding: 10px;*/\n/*}*/\n\n.discussion-board .dis-middle .data-list {\n    height: 100%;\n    max-height: 600px;\n    padding-bottom: 5px;\n    overflow: auto;\n}\n\n.pinImage {\n    display: none;\n}\n\n.discussion-board .dis-middle .data-list .weekend {\n    padding: 10px;\n    display: flex;\n    gap: 8px;\n    margin: 2px;\n    position: relative;\n}\n\n.discussion-board .dis-middle .data-list .weekend:hover {\n    /* background-color: #fafafa; */\n    box-shadow: 0 0 2px 0 rgb(0 0 0 / 50%);\n}\n\n.discussion-board .dis-middle .data-list .weekend .profile-image {\n    border-radius: 4px;\n    width: 32px;\n    height: 32px;\n    position: absolute;\n    font-size: 15px;\n    cursor: pointer;\n}\n\n.discussion-board .dis-middle .data-list .weekend .ago {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.discussion-board .dis-middle .data-list .weekend .ago h6 {\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 15px;\n    color: #0f062b;\n    margin-bottom: 0;\n    margin-right: 4px;\n    white-space: nowrap;\n}\n\n.discussion-board .dis-middle .data-list .weekend .ago span.span {\n    font-weight: 900;\n    font-size: 15px;\n    color: #0f062b;\n    margin: 0 5px;\n}\n\n.discussion-board .dis-middle .data-list .weekend .ago span {\n    font-weight: 500;\n    font-size: 12px;\n    color: #878395;\n}\n\n.discussion-board .dis-middle .data-list .weekend .meni {\n    width: 100%;\n    margin-left: 40px;\n}\n\n.weekend .meni .comment-text {\n    margin-bottom: 0;\n    font-weight: 400;\n    font-size: 15px;\n    /*color: #878395;*/\n}\n\n.comment-text .replyComment{\n    text-wrap: wrap;\n    display: block;\n    overflow-wrap: anywhere;\n}\n\n.discussion-board .dis-middle .data-list .weekend .meni .lier {\n    display: flex;\n    align-items: center;\n    /* width: 400px; */\n}\n\n.discussion-board .dis-middle .data-list .weekend .meni .lier .sub {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.discussion-board .dis-middle .data-list .weekend .meni .lier .sub-2 {\n    min-width: 150px;\n    width: 100%;\n}\n\n.discussion-board .dis-middle .data-list .weekend .meni .lier .sub-2 button,\n.discussion-board .dis-middle .data-list .weekend .meni .lier .sub button {\n    border: 0;\n    outline: 0;\n    background-color: transparent;\n    padding: 5px;\n}\n\n.discussion-board .dis-middle .data-list .weekend .meni .lier .sub .zero {\n    font-weight: 400;\n    font-size: 13px;\n    color: #0f062b;\n    margin-bottom: 0;\n}\n\n.discussion-board .dis-middle .data-list .weekend .meni .lier .sub-2 .zero {\n    font-size: 14px;\n    color: #007bff;\n    font-weight: 500;\n}\n\n.discussion-board .dis-middle .data-list .weekend .meni .lier .sub-2 .zero svg {\n    margin-left: 5px;\n    margin-bottom: 2px;\n}\n\n.discussion-board .dis-middle .data-list .weekend:hover .meni .lier .sub-3 {\n    display: flex;\n}\n\n.discussion-board .dis-middle .data-list .weekend .meni .lier .sub-3 {\n    display: none;\n    align-items: center;\n    gap: 8px;\n}\n\n.discussion-board .dis-middle .data-list .weekend .meni .lier .sub-3 button {\n    width: 59px;\n    height: 30px;\n    border-radius: 5px;\n    font-weight: 400;\n    font-size: 12px;\n    color: #ffffff;\n    border: 0;\n    outline: 0;\n}\n\n.discussion-board .dis-middle .data-list .weekend .meni .lier .sub-3 button.up {\n    background-color: #6c2fbb;\n}\n\n.discussion-board .dis-middle .data-list .weekend .meni .lier .sub-3 button.del {\n    background-color: #c401ec;\n}\n\n.replysection:hover .replyDelete{\n    display: flex;\n    justify-content: end;\n    padding-right: 15px;\n    gap: 5px;}\n\n.replyDelete{\n    display: none;\n    text-align: center;\n}\n\n.replyDelete button{\n    background-color: #c401ec;\n    width: 59px;\n    height: 30px;\n    border-radius: 5px;\n    font-weight: 400;\n    font-size: 12px;\n    color: #ffffff;\n    border: 0;\n}\n\n\n.replyDelete button.up {\n    background-color: #6c2fbb;\n}\n\n.discussion-board .reply-input {\n    border-left: 0;\n    border-right: 0;\n    border-top: 0;\n    border-bottom: 0.12rem solid #80808030;\n    /* background: transparent; */\n    outline: none;\n}\n\n#offcanvasRight .reply-btn {\n    border: none;\n    background: #6c2fbb;\n    color: white;\n    padding: 2px 11px;\n    border-radius: 4px;\n    font-size: 15px;\n}\n\n.c-cmt {\n    font-weight: 600;\n    cursor: pointer;\n}\n.c-cmt:hover {\n    text-decoration: underline;\n}\n\n.discussion-board .comment-video {\n    cursor: pointer;\n    display: inline-block;\n    height: 60px;\n    position: relative;\n}\n\n.discussion-board .comment-video .playicon {\n    color: #6c2fbb;\n    border-radius: 50%;\n    font-size: 24px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    -o-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n}\n\n.discussion-board .comment-video img {\n    width: auto;\n    height: inherit;\n}\n\n\n.update-btn {\n    border: none;\n    background: #8600ff;\n    border-radius: 5px;\n    color: white;\n    padding: 4px 30px;\n}\n\n.edit-bus-btn {\n    border: none;\n    /*color: #6c2fbb;*/\n    color: inherit;\n    box-shadow: none;\n    margin-left: 5px;\n}\n\nbutton.edit {\n    margin-left: 10px;\n    top: -3px;\n    /* right: -35px; */\n    content: \"\";\n    width: 23px;\n    height: 23px;\n    background: transparent;\n    border-radius: 6px;\n    border: 0;\n    overflow: hidden;\n    position: relative;\n}\n\n#update_business_modal .form-control {\n    box-shadow: none !important;\n}\n\n#update_business_modal .form-control:focus {\n    border-color: #6c2fbb;\n}\n\n.video-container {\n    height: 50vh;\n}\n\n.banner {\n    box-shadow: 0 1px 1px rgba(0, 0, 0, 10%) !important;\n    background: #6438b4;\n    border: #6438b4;\n    color: #fff;\n    border-radius: 0;\n    z-index: 1;\n}\n\n.bannerSecGuest {\n    width: 100%;\n    margin: 9px 0;\n    /* position: absolute; */\n    left: 0;\n    right: 0;\n    /* top: 70px; */\n    top: 0;\n    height: max-content;\n}\n\n.bannerSec {\n    margin: 9px -22px;\n    position: relative;\n    /*bottom: 36px;*/\n}\n\n.rag-body {\n    max-height: 80vh;\n    overflow: auto;\n}\n\n.rag-list {\n    width: 500px;\n    max-width: 100%;\n    border: solid 1px #ccc;\n    min-height: 60px;\n    display: block;\n    background: white;\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.rag-box {\n    padding: 10px;\n    border-bottom: solid 1px #ccc;\n    color: rgba(0, 0, 0, 0.87);\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n    cursor: move;\n    background: white;\n    font-size: 14px;\n    z-index: 99999;\n}\n\n.rag-box:last-child {\n    border: none;\n}\n\n.cdk-drag-preview {\n    box-sizing: border-box;\n    border-radius: 4px;\n    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\n        0 8px 10px 1px rgba(0, 0, 0, 0.14),\n        0 3px 14px 2px rgba(0, 0, 0, 0.12);\n}\n\n.cdk-drag-animating {\n    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.rag-list.cdk-drop-list-dragging .rag-box:not(.cdk-drag-placeholder) {\n    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.rag-custom-placeholder {\n    background: #ccc;\n    border: dotted 3px #999;\n    min-height: 110px;\n    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.rag-img-box {\n    width: 100px;\n    height: 80px;\n    margin-right: 10px;\n    display: flex;\n    justify-content: center;\n    border-radius: 8px;\n    background: #f8f9fa;\n}\n\n.rag-img {\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n}\n\n/* settings */\n.cm-settings {\n    background-color: #eee;\n    border-radius: 0 0 0 10px;\n    color: #212529;\n    padding: 20px 50px;\n    position: fixed;\n    top: 128px;\n    right: 0;\n    /*height: 400px;*/\n    transform: translateX(100%);\n    transition: transform 0.4s ease;\n    z-index: 99;\n}\n\n.cm-settings.active {\n    transform: translateX(0);\n}\n\n.cm-settings .toggle {\n    border: none;\n    cursor: pointer;\n    font-size: 20px;\n    padding: 10px 15px;\n    position: absolute;\n    top: 0;\n    left: 0px;\n    transform: translateX(-100%);\n    background: #eee;\n    color: #212121;\n    border-radius: 10px 0 0 10px;\n}\n\n.cm-settings.active .toggle i {\n    animation: spin 3s linear infinite;\n}\n\n\n/* =================================== */\n.offcanvas-header {\n    border-bottom: 1px solid #d2d2d2;\n}\n\n.mytextdiv {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 5px;\n}\n\n.mytexttitle {\n    flex-grow: 0;\n    font-size: 15px;\n    color: gray;\n}\n\n.divider {\n    flex-grow: 1;\n    height: 1px;\n    background-color: #e0dede;\n}\n\n.offcanvas-end {\n    width: 600px;\n}\n\n.lastReply{\n    color: gray;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.zero:hover{\n    text-decoration: underline;\n}\n/* =================================== */\n\n\n.tab-box-video {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 16px;\n}\n\n.tab-box-video ul {\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    overflow: auto;\n    scrollbar-width: none;\n    width: 100%;\n    margin-bottom:0;\n    /* justify-content: center; */\n}\n\n.tab-box-video ul li {\n    position: relative;\n    list-style: none;\n    font-weight: 500;\n    font-size: 18px;\n    padding: 5px  10px 0 10px;\n    margin: 0 15px;\n    color: #878395;\n    cursor: pointer;\n}\n\n.tab-box-video ul li svg {\n    fill: #878395;\n}\n\n.tab-box-video ul li.active {\n    border-top: 3px solid #6c2fbb;\n    color: #6c2fbb;\n}\n\n.tab-box-video ul li.active svg {\n    fill: rgba(108, 47, 187, 1);\n}\n\n.tab-box-video ul li .add-tab {\n    color: #6c2fbb;\n    background: #e1e1f9;\n}\n\n.tab-box-video ul li .delete-tab-2 {\n    display: none;\n    color: #dc3545;\n}\n\n.edit-tab svg {\n    height: 16px;\n    width: 16px;\n    fill: black !important;\n    margin-right: 5px;\n    display: none;\n}\n\n.isPinned {\n    background-color: #f1eafe8c;\n    border: 1px solid #ae88df;\n    border-radius: 4px;\n}\n\n.tab-box-video ul li:hover .delete-tab-2 {\n    display: inline-block;\n} \n\n.tab-box-video ul li:hover .edit-tab svg {\n    display: inline-block;\n}\n\n.tab-box-video ul li:hover .pinImage {\n    display: inline-block;\n}\n\n\n.discussionBoard h2{\n    width: 100%;\n    max-width: fit-content;\n}\n\n.discussionBoard .tab-box-video ul li .delete-tab-2 {\n    display: none;\n    color: #dc3545;\n    position: unset;\n    padding: 0 0 0 5px;\n}\n.discussionBoard  .tab-box-video ul li:hover .delete-tab-2 {\n    display: inline-block;\n}\n\n#reOrderGroupTopic .rag-box {\n    padding: 10px;\n    border-bottom: solid 1px #ccc;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n    cursor: move;\n    background: white;\n    z-index: 99999;\n    font-size: 18px;\n    font-weight: 500;\n    color: #878395;\n}\n\n#reOrderGroupTopic .rag-custom-placeholder {\n    background: #ccc;\n    border: dotted 3px #999;\n    min-height: 50px;\n    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n::ng-deep .pricing-dialog {\n    overflow: auto;\n}\n\n::ng-deep .pricing-dialog .mat-dialog-container{\n\n    display: block;\n    padding: 24px;\n    border-radius: 4px;\n    box-sizing: border-box;\n    overflow: auto;\n    outline: 0;\n    width: 100%;\n    height: 100%;\n    min-height: inherit;\n    max-height: inherit;\n    margin: 20px 0;\n\n}\n\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.cm-settings .settings ul {\n    list-style: none;\n}\n\n.cm-settings .settings ul li {\n    margin: 20px 0;\n}\n\n.template-1-main {\n    background-color: #fff;\n    border-radius: 16px;\n}\n\n.template-1-header .seller-profile {\n    padding: 18px 40px;\n    border-bottom: 1px solid #dee2e6;\n    text-align: right;\n}\n\n.template-1-header .seller-profile .user-profile-pic {\n    width: 50px !important;\n    height: 50px !important;\n    border-radius: 13px;\n    margin-right: 10px;\n}\n\n.templates-option li {\n    cursor: pointer;\n}\n\n.templates-option li:hover,\n.templates-option li.active {\n    color: #6c2fbb;\n}\n\n.panels {\n    border-radius: 16px;\n    border: 1px solid #dee2e6;\n}\n\n.iframe-video {\n    border-radius: 16px;\n}\n\n.mobile-view a {\n    color: inherit;\n}\n\n.attachments .attachments-item {\n    width: auto !important;\n}\n\n.actionButton{\n    /* position: absolute; */\n    bottom: 0;\n    display: flex;\n    gap: 10px;\n    width: 100%;\n    justify-content: flex-end;;\n    padding: 5px;\n    background-color: white;\n    /* border: 1px solid #959697; */\n    /* border-top: 1px solid #d6d6d6; */\n    border-left: 1px solid #959697;\n    border-right: 1px solid #959697;\n    border-bottom: 1px solid #959697;\n}\n\n.reply .actionButton{\n    bottom: 100px !important;\n}\n\n.actionButton button{\n    border-radius: 5px !important;\n    padding: 4px 8px !important;\n    height: unset !important;\n    width: unset !important;\n    border: none !important;\n}\n\n.actionButton button img{\n    filter: invert(1);\n    position: unset !important;\n    height: 20px !important;\n    width: 20px !important;\n}\n\n.actionButton button label{\n    color: white !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    position: unset !important;\n    background-color: unset !important;\n    height: unset !important;\n    width: unset !important;\n}\n.actionButton .btnCancelReply {\n    background: #6c2fbb;\n    border-radius: 5px !important;\n    padding: 4px 8px;\n    height: unset !important;\n    width: unset !important;\n    font-size: 15px;\n    color: white;\n    border: none !important;\n}\n.btnJoin{\n    width: fit-content;\n    border-radius: 5px;\n    border: solid 1px #6c2fbb;\n    background-color: #6c2fbb;\n    font-size: 15px;\n    padding: 5px 25px;\n    color: white;\n}\n\n.btnCancel{\n    width: fit-content;\n    /* margin: 0; */\n    border-radius: 5px;\n    border: none;\n    background-color: #6c2fbbd1;\n    font-size: 15px;\n    padding: 6px 15px;\n    /* width: 100%; */\n    color: white;\n}\n\n.errorMsg{\n    text-align: center;\n    margin: 33px 0 10px 0;\n    font-size: 18px;\n}\n\n#modalForAllGroups .title{\n    color: #212529;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-align: center;\n    font-size: 17px;\n    margin-top: 7px;\n    font-weight: 400 \n}\n#modalForAllGroups .modal-body {\n    height: calc(100vh - 200px);\n    overflow-y: auto;\n}\n::ng-deep .tooltip001 {\n    position: absolute;\n    background-color: white;\n    border: 1px solid #ccc;\n    padding: 10px 13px;\n    box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n    z-index: 1000; \n}\n::ng-deep .tooltip001 span {\n   display: flex;\n   align-items: center;\n   gap: 10px;\n}\n::ng-deep .tooltip001 img {\n    width: 50px;\n    height: 50px;\n    border-radius: 5px;\n}\n::ng-deep .tooltip001 .profile-image {\n    width: 50px;\n    height: 50px;\n    border-radius: 5px;\n    font-size: 18px;\n}\n\n@media (max-width: 1199px) {\n    .cm-main { \n        max-height: unset;\n        height: auto;\n    }\n    .mobile-view,\n    .mobile-view-name {\n        text-align: center;\n        justify-content: center;\n    }\n    .main-featured .tabMenu {\n        position: unset;\n        justify-content: flex-end;\n        width: 100%;\n    }\n    .main-featured .userAddedTab {\n        gap: 0;\n        margin-top: 10px;\n        width: 100%;\n        margin-bottom: 15px;\n    }\n}\n@media (max-width: 991px) {\n    .edit-tab svg{\n        display: inline-block !important;\n    }\n\n        .pinImage {\n            display: inline-block !important;\n        }\n\n    .userAddedTab p span {\n        margin: 0 24px 0 0;\n    }\n    .delete-tab {\n        display: block;\n        right: 12px;\n    }\n    .tab-box-video ul li .delete-tab-2 {\n        display: inline-block;\n    }\n}\n@media (max-width: 768px) {\n    .tab-box-video {\n        align-items: baseline;\n    }\n    .tab-box-video ul {\n        margin-inline: 10px;\n    }\n    .featured-video {\n        display: flex;\n        overflow-x: auto;\n        overflow-y: hidden;\n    }\n    .featured-video .userAddedTab {\n        margin-inline: 10px;\n    }\n}\n@media (max-width: 600px) {\n    .group-box {\n        border-radius: 0 0 16px 16px;\n    }\n}\n@media (max-width: 575px) {\n    .lier {\n        flex-direction: column;\n        align-items: flex-start !important;\n    }\n    .lier .sub-2 {\n        width: 100% !important;\n    }\n    .lier .sub-2 img {\n        width: 22px;\n    }\n    .cm-settings {\n        padding: 20px;\n    }\n}\n@media (max-width: 450px) {\n    .light-scroll.memmber-list {\n        flex-wrap: nowrap;\n    }\n    .light-scroll.memmber-list >div:first-child {\n        padding: 0;\n    }\n    .light-scroll.memmber-list >div:nth-child(2) {\n        padding-right: 0;\n    }\n    .light-scroll.memmber-list >div .lecture-name {\n        margin-left: 10px;\n    }\n    .cm-settings {\n        width: 260px;\n    }\n    .cm-settings .settings-wrapper ul {\n        flex-wrap: wrap;\n    }\n    .cm-settings .settings-wrapper ul li {\n       margin: 0;\n    }\n    .cm-settings ul li .btnFeaturedVideo {\n       font-size: 13px;\n    }\n    #offcanvasRight .offcanvas-body .position-sticky {\n        margin-top: -50px;\n    }\n}\n@media (max-width: 430px) {\n    .tab-box-group ul {\n        flex-direction: column;\n        border-bottom: 1px solid #e5e5e5;\n        width: 100%;\n        padding-bottom: 10px;\n        padding-top: 17px;    \n    }\n    .group-box .dots {\n        padding-inline: 5px;\n    }\n    .group-box .next p {\n        margin: 0 !important;\n    }\n    .group-box .next p a {\n       font-size: 14px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
